




























import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { Stack } from '../../Toolbar/types'

@Component
export default class PlaceholderSections extends Vue {
  @Prop({ type: Array, required: true, default: () => [] }) sections!:Array<Stack>

  activeBtnIndex: number | null = null

  activeSectionIndex: number | null = null

  @Emit()
  selectSection(sectionIndex:number, btnIndex:number):{sectionIndex:number, btnIndex:number} {
    this.activeBtnIndex = btnIndex
    this.activeSectionIndex = sectionIndex

    return { sectionIndex, btnIndex }
  }
}
